import { AppointmentType } from '@weave/schema-gen-ts/dist/schemas/schedule/v3/appointment_type.pb';
import { useGetScheduleRequestListQueries } from '../../views/Calendar/EventsPanel/ScheduleActions/ScheduleRequests/hooks/useGetScheduleRequestListQueries';
import { useConvertScheduleRequestToEvent } from './use-convert-schedule-request-to-event';

type UseCalendarScheduleRequestsParams = {
  locationIds: string[];
  calendarDate: string;
  appointmentTypes?: AppointmentType[];
};

export const useCalendarScheduleRequests = ({
  locationIds,
  calendarDate,
  appointmentTypes,
}: UseCalendarScheduleRequestsParams) => {
  const { scheduleRequests, refetch } = useGetScheduleRequestListQueries({ locationIds, date: calendarDate });

  const { scheduleRequestEventsData } = useConvertScheduleRequestToEvent(scheduleRequests, appointmentTypes);

  return {
    scheduleRequests,
    scheduleRequestEventsData,
    refetchScheduleRequestList: refetch,
  };
};
